// removed by extract-text-webpack-plugin
module.exports = {"aboutRealtor":"_3OVn6c2m4-fWxikBtC6P3o"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AboutRealtor/AboutRealtor.scss
// module id = 1556
// module chunks = 0